import { _orderBy, isVisibleElement, parseUTCDate } from "../../../utils/FPEUtils";

/**
 * CanvasMapとGoogleMapのDomを取得する
 * @return {[HTMLElement,HTMLElement]}
 */
export const getMapDivs = () => {
  return [
    document.getElementById('canvas-map'),
    document.getElementById('google-map')
  ]
};

/**
 * 表示中の地図のDomを取得する
 * @return {[HTMLElement,HTMLElement]}
 */
export const getActiveMapDiv = () => {
  return getMapDivs().find(div => {
    return isVisibleElement(div)
  });
};

/**
 * 現在の画面サイズに合わせて地図のズームレベル範囲を取得する
 * @returns {{min_zoom: number, max_zoom: number}}
 */
export const getZoomRange = () => {
  const width = document.getElementById('map-wrap').clientWidth;
  const min = Math.LOG2E * Math.log(width / 190);
  return {
    min_zoom: min,
    max_zoom: 18
  }
}

export const nearValidTime =(timeList, targetTime, option) => {
  if (!timeList || timeList.length === 0) return null;

  let _targetTime;
  if (typeof targetTime === 'number') {
    _targetTime = targetTime
  } else {
    _targetTime = parseUTCDate(targetTime).getTime();
  }

  const tmpTimeList = timeList.reduce((accumulator, validtime) => {
    const utc = parseUTCDate(validtime);
    const validSec = utc.getTime();
    if (option?.onTheHour) {
      // 正時のみにフィルタリング
      if (utc.getMinutes() !== 0 || utc.getSeconds() !== 0) {
        return accumulator;
      }
    }
    if (option?.filterFuture) {
      // 未来時制を除外する
      if (_targetTime < validSec) {
        return accumulator;
      }
    }
    accumulator.push(
      {
        "validtime": validtime,
        "validtime_msec": validSec
      }
    );
    return accumulator;
  }, []);

  // targetTimeに最も近いvalidを選択する(直近が過去時制と未来時制で同時刻の場合、未来時制のValidデータを採用する。)
  const sortedTimelist = _orderBy(tmpTimeList, [
    o => {
      return Math.abs(_targetTime - o.validtime_msec);
    },
    'validtime'
  ], ['asc', 'desc']);

  const selectedTime = sortedTimelist[0];

  return selectedTime?.validtime;
}